import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import {
  fetchDeliveryListData,
  fetchDeliveryVendor,
  deleteDeliveryData,
  updateDeliveryData,
  addDeliveryData,
  moveDeliveryData,
} from "../thunks/deliveryThunks";

import type {
  DeliveryPayload,
  DeliveryVendor,
} from "../../utils/types/delivery";
import type { PayloadAction } from "@reduxjs/toolkit";

interface DeliveryState {
  deliveryList: {
    [key: string]: DeliveryVendor[] | undefined;
  } | null;
  deliveryVendor: DeliveryPayload[]; // Stores delivery vendor data
  listLoading: boolean;
  vendorLoading: boolean;
  listError: string | null;
  vendorError: string | null;
}

const initialState: DeliveryState = {
  deliveryList: null,
  deliveryVendor: [],
  listLoading: false,
  vendorLoading: false,
  listError: null,
  vendorError: null,
};

const deliverySlice = createSlice({
  name: "delivery",
  initialState,
  reducers: {
    // clearDeliveries(state) {
    //   state.deliveryList = [];
    //   state.deliveryVendor = [];
    // },
  },
  extraReducers: (builder) => {
    builder
      // Handling fetchDeliveryListData separately
      .addCase(fetchDeliveryListData.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(fetchDeliveryListData.fulfilled, (state, action) => {
        state.listLoading = false;
        // state.deliveryList = action.payload || [];
        const { payload } = action;

        const { jobId } = payload;
        if (!jobId) {
          state.listError = "Invalid job ID";
          return;
        }

        if (!state.deliveryList) {
          state.deliveryList = {};
        }
        state.deliveryList[jobId] = payload.data || [];
      })
      .addCase(fetchDeliveryListData.rejected, (state) => {
        state.listLoading = false;
        state.listError = "Failed to fetch delivery list.";
      });
    builder
      // Handling fetchDeliveryVendor separately
      .addCase(fetchDeliveryVendor.pending, (state) => {
        state.vendorLoading = true;
        state.vendorError = null;
      })
      .addCase(
        fetchDeliveryVendor.fulfilled,
        (state, action: PayloadAction<DeliveryPayload[]>) => {
          state.vendorLoading = false;
          state.deliveryVendor = action.payload || [];
        }
      )
      .addCase(fetchDeliveryVendor.rejected, (state, action) => {
        state.vendorLoading = false;
        state.vendorError =
          (action.payload as string) || "Failed to fetch delivery vendor.";
      });

    builder
      .addCase(deleteDeliveryData.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(deleteDeliveryData.fulfilled, (state, action) => {
        state.listLoading = false;
        // state.deliveryList = state.deliveryList.filter(
        //   (operation) =>
        //     action.payload?.deliveryVendorId !== operation.deliveryVendorId
        // );
        // if (state.deliveryList) {
        //   Object.keys(state.deliveryList).forEach((berthId) => {
        //     state.deliveryList![berthId] = state.deliveryList![berthId].filter(
        //       (delivery) =>
        //         action.payload?.deliveryVendorId !== delivery.deliveryVendorId
        //     );
        //   });
        // }
        const { payload } = action;
        if (!payload || !payload.jobId || !payload?.deliveryVendorId) {
          state.listError = " Invalid job ID or delivery vendor ID";
          return;
        }

        if (!state.deliveryList || !state.deliveryList[payload.jobId]) {
          return;
        }

        if (state.deliveryList[payload.jobId]) {
          state.deliveryList[payload.jobId] = state.deliveryList[
            payload.jobId
          ]!.filter(
            (delivery) =>
              payload?.deliveryVendorId !== delivery.deliveryVendorId
          );
        }
      })
      .addCase(deleteDeliveryData.rejected, (state) => {
        state.listLoading = false;
        state.listError = "Unknown error… Please try again";
      });
    builder
      .addCase(updateDeliveryData.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(updateDeliveryData.fulfilled, (state, action) => {
        state.listLoading = false;
        // state.deliveryList = state.deliveryList.map((operation) => {
        //   if (
        //     operation.deliveryVendorId ===
        //     action.payload?.data?.deliveryVendorId
        //   ) {
        //     return { ...operation, ...action.payload.data };
        //   }
        //   return operation;
        // });
        // if (state.deliveryList) {
        //   state.deliveryList[action.payload.berthId] = (
        //     state.deliveryList[action.payload.berthId] || []
        //   ).map((delivery) => {
        //     if (
        //       delivery.deliveryVendorId ===
        //       action.payload?.data?.deliveryVendorId
        //     ) {
        //       return { ...delivery, ...action.payload?.data };
        //     }
        //     return delivery;
        //   });
        // }
        const { payload } = action;
        if (!payload || !payload.jobId || !payload?.deliveryVendorId) {
          state.listError = " Invalid job ID or delivery vendor ID";
          return;
        }

        if (!state.deliveryList || !state.deliveryList[payload.jobId]) {
          return;
        }

        if (state.deliveryList[payload.jobId]) {
          state.deliveryList[payload.jobId] = state.deliveryList[
            payload.jobId
          ]?.map((delivery) => {
            if (delivery.deliveryVendorId === payload?.data?.deliveryVendorId) {
              return { ...delivery, ...action.payload?.data };
            }
            return delivery;
          });
        }
      })
      .addCase(updateDeliveryData.rejected, (state) => {
        state.listLoading = false;
        state.listError = "Unknown error… Please try again";
      });
    builder
      .addCase(addDeliveryData.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(addDeliveryData.fulfilled, (state, action) => {
        state.listLoading = false;
        // if (state.deliveryList) {
        //   if (!state.deliveryList[action.payload.berthId]) {
        //     state.deliveryList[action.payload.berthId] = [];
        //   }
        //   state.deliveryList[action.payload.berthId] = [
        //     action.payload,
        //     ...state.deliveryList[action.payload.berthId],
        //   ];
        // }
        const { payload } = action;
        if (!payload) {
          return;
        }

        const jobId = payload?.jobId;
        if (!jobId) {
          state.listError = "Invalid job ID in response";
          return;
        }

        if (!state.deliveryList) {
          state.deliveryList = {};
        }

        const existingDeliveries = state.deliveryList[jobId] || [];
        state.deliveryList[jobId] = [payload.data, ...existingDeliveries];
      })
      .addCase(addDeliveryData.rejected, (state) => {
        state.listLoading = false;
        state.listError = "Unknown error… Please try again";
      });

    builder
      .addCase(moveDeliveryData.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(moveDeliveryData.fulfilled, (state, action) => {
        state.listLoading = false;
        // if (state.deliveryList) {
        //   Object.keys(state.deliveryList).forEach((berthId) => {
        //     state.deliveryList![berthId] = state.deliveryList![berthId].filter(
        //       (delivery) => action.payload?.id !== delivery.deliveryVendorId
        //     );
        //   });
        // }
        const { payload } = action;
        if (!payload || !payload.jobId || !payload?.deliveryVendorId) {
          state.listError = " Invalid job ID or delivery vendor ID";
          return;
        }

        if (!state.deliveryList || !state.deliveryList[payload.jobId]) {
          return;
        }

        if (state.deliveryList[payload.jobId]) {
          state.deliveryList[payload.jobId] = state.deliveryList[
            payload.jobId
          ]?.map((delivery) => {
            if (delivery.deliveryVendorId === payload?.deliveryVendorId) {
              return { ...delivery, berthId: action.payload?.data.berthId };
            }
            return delivery;
          });
        }
      })
      .addCase(moveDeliveryData.rejected, (state) => {
        state.listLoading = false;
        state.listError = "Unknown error… Please try again";
      });

    addWebSocketCases(builder, "delivery", "deliveryList");
  },
});

// export const { clearDeliveries } = deliverySlice.actions;
export default deliverySlice.reducer;
